import React from 'react';
import DailyTask from './Components/DailyTask';
import useDailyTask from './useDailyTask';

const DailyTaskIndex: React.FC = () => {
  const dailyTaskProps = useDailyTask();

  return (
  <DailyTask/>
);
};
export default DailyTaskIndex;
